import { useState } from 'react';
import { Tabs } from 'antd';
import PayoutReportTab from './Tabs/PayoutReportTab/PayoutReportTab';

function NewPayoutReportListPage() {
  const [tabActiveKey, setTabActiveKey] = useState('1');

  const onChange = (key) => {
    setTabActiveKey(key);
  };

  const items = [
    {
      key: '1',
      label: 'Reports',
      children: <PayoutReportTab />
    }
  ];

  return (
    <div style={{ padding: '24px' }}>
      <Tabs activeKey={tabActiveKey} items={items} onChange={onChange} />
    </div>
  );
}

export default NewPayoutReportListPage;
